import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { SelectField } from './select-field.js';
const DIR_LABEL = {
    desc: 'по убыванию',
    asc: 'по возрастанию',
};
const NONE = '__default__';
/**
 * Сортировка таблицы в виде карточек (`ResponsiveTableList` на телефоне):
 * заголовков колонок там нет, поэтому `SortableHeader` недоступен — тот же
 * выбор «колонка + направление» одним списком. Состояние то же `SortState`,
 * что у заголовков: экран кладёт его в URL/запрос одним обработчиком.
 */
export function SortSelect({ id, sort, options, onSortChange, label = 'Сортировка', className = 'md:hidden', }) {
    const items = options.flatMap((o) => {
        const first = o.defaultDirection ?? 'desc';
        const second = first === 'desc' ? 'asc' : 'desc';
        return [first, second].map((dir) => ({
            value: `${o.key}:${dir}`,
            label: `${o.label} — ${DIR_LABEL[dir]}`,
        }));
    });
    const current = sort ? `${sort.key}:${sort.dir}` : NONE;
    const known = items.some((i) => i.value === current);
    return (_jsx(SelectField, { id: id, label: label, className: cn(className), value: known ? current : NONE, onChange: (v) => {
            const i = v.lastIndexOf(':');
            if (i <= 0)
                return;
            onSortChange({ key: v.slice(0, i), dir: v.slice(i + 1) });
        }, options: known ? items : [{ value: NONE, label: 'По умолчанию' }, ...items] }));
}
//# sourceMappingURL=sort-select.js.map